// IMOTEpS — Centre de recherche / Chapitre 10
// Auto-split from chapters.js (Feb 2026 refactor)

export const chapter10 = {
  id: 10,
  slug: "tendinopathies-coude",
  color: "#8B3A1A",
  title: "Tendinopathies chroniques du coude",
  subtitle: "Épicondylite, épitrochléite, biceps distal — diagnostic et chirurgie",
  region: "Coude",
  readingMin: 21,
  summary:
    "Physiopathologie commune (angiofibroplasie hyperplasique de Kraushaar & Nirschl), 80–90 % de guérison spontanée à 1-2 ans, examens cliniques précis (test coude EXTENSION = clé), traitement conservateur (12 mois mini avant chirurgie), techniques chirurgicales personnelles du Dr Aswad.",
  sections: [
    {
      heading: "1. Physiopathologie commune",
      body: "La révolution Kraushaar & Nirschl (1999) a démontré que les tendinopathies chroniques ne sont PAS des inflammations mais des angiofibroplasies hyperplasiques : remplacement du collagène I par du collagène III désorganisé, néovascularisation douloureuse, absence d'infiltrat inflammatoire chronique. Donnée fondamentale : 80 à 90 % de guérison spontanée à 1-2 ans.",
    },
    {
      heading: "2. Épicondylite latérale (tennis-elbow)",
      body: "Anatomie : court extenseur radial du carpe (CERC/ECRB) avec rapport étroit avec l'arcade de Frohse et la branche profonde du nerf radial. Test clé : douleur reproduite par extension contrariée du poignet COUDE EN EXTENSION (et beaucoup moins coude fléchi). Imagerie utile : échographie, IRM préopératoire.",
    },
    {
      heading: "3. Épitrochléite (golfer's elbow)",
      body: "Anatomie : insertion du rond pronateur et des fléchisseurs sur l'épitrochlée. Alerte : nerf ulnaire associé dans 30 à 60 % des cas — diagnostic manqué fréquent. Test clé : pronation contrariée COUDE EN EXTENSION.",
    },
    {
      heading: "4. Tendinopathie distale du biceps",
      body: "Physiopathologie par friction mécanique en pronation dans l'espace radio-ulnaire. Tests : supination contrariée, palpation profonde, Hook test (intégrité du tendon), IRM en position FABS. ⚠️ DANGER : les infiltrations corticoïdes au tendon distal du biceps exposent à un risque documenté de rupture iatrogène.",
    },
    {
      heading: "5. Traitement conservateur",
      body: "Décharge relative → rééducation excentrique++ → infiltration (1-2 maximum) → ergonomie. Le bracelet de contre-force a démontré son efficacité (Kroslak RCT 2019). Minimum 12 mois d'évolution avant toute décision chirurgicale.",
    },
    {
      heading: "6. Technique chirurgicale personnelle — Dr Aswad",
      body: "Pour l'épicondylite latérale : aponévrotomie profonde du CERC + libération du chef superficiel du court supinateur (décompression de la branche profonde du nerf radial à travers l'arcade de Frohse). Attelle 1 mois, kinésithérapie à J15, renforcement à S6.\n\nPour l'épitrochléite : aponévrotomie de l'aponévrose profonde du rond pronateur ± transposition antérieure du nerf ulnaire si névralgie ulnaire associée.",
    },
  ],
  references: [
    { id: 1, text: "Kraushaar BS, Nirschl RP. Tendinosis of the elbow (tennis elbow). JBJS Am. 1999;81(2):259-78.", pubmed: "10073590" },
    { id: 2, text: "Kroslak M, et al. Counterforce bracing of lateral epicondylitis: RCT. JSES. 2019.", pubmed: "30771916" },
    { id: 3, text: "Muir B, et al. Lateral epicondylitis in workers' compensation: outcome differences. JSES Reviews. 2024." },
  ],
};
